import React, { useEffect, useState } from 'react'
import { Button, Spin, Alert, message } from 'antd'
import { readClinicalNotes } from '../../../examination-utils/examination-lib'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilePdf } from '@fortawesome/free-solid-svg-icons'
import { generateCraftMyPdfReport } from '../../../../Invoices/utils'
import ClinicalNotesReportTemplate from './ClinicalNotesReportTemplate'
import { createDocument } from '../utils/api'
import { documentsTypes } from '../utils/enums'
import { MODAL_STATES } from '../utils/constants'
import dayjs from 'dayjs'
import { blobToBase64 } from '../../../../lib/utils'

const Report = ({
  bookingId,
  setModalOpen,
  bookingData,
  patientRecord,
  medicalProfRecord,
  clinicRecord,
  handleAfterSuccess
}) => {
  const [notes, setNotes] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [generating, setGenerating] = useState(false)

  useEffect(() => {
    const fetchNotes = async () => {
      setLoading(true)
      setError('')
      try {
        const data = await readClinicalNotes({ bookingRef: bookingId })
        setNotes(data)
      } catch (err) {
        setError('Failed to load clinical notes.')
      } finally {
        setLoading(false)
      }
    }
    if (bookingId) fetchNotes()
  }, [bookingId])

  const handleGeneratePDF = async () => {
    setGenerating(true)
    setError('')
    try {
      const html = ClinicalNotesReportTemplate({
        notes,
        bookingData,
        patientRecord,
        medicalProfRecord,
        clinicRecord
      })

      const templateId = 'b1b77b233fd40c3c' // Same as Invoicing
      const url = await generateCraftMyPdfReport(html, templateId)

      // Convert the PDF URL to base64
      const response = await fetch(url)
      const blob = await response.blob()
      const base64data = await blobToBase64(blob)

      // Create document record
      const newRecord = await createDocument(
        base64data,
        {
          name: `Clinical Notes Report (${dayjs().format('DD-MM-YYYY')})`,
          userRef: bookingData?.userRef || patientRecord?._id,
          bookingRef: bookingData?._id || ''
        },
        documentsTypes.REPORT
      )

      message.success('Clinical notes report generated successfully!')
      handleAfterSuccess(MODAL_STATES.REPORT, newRecord)
    } catch (err) {
      setError('Failed to generate PDF.')
      message.error('Failed to generate PDF.')
    } finally {
      setGenerating(false)
    }
  }

  return (
    <div style={{ padding: '20px' }}>
      {loading ? (
        <Spin tip='Loading clinical notes...' />
      ) : error ? (
        <Alert type='error' message={error} />
      ) : (
        <>
          <h3>Clinical Notes for this Booking</h3>
          <div
            style={{
              marginBottom: 24,
              maxHeight: 300,
              overflowY: 'auto',
              border: '1px solid #d9d9d9',
              padding: 16,
              borderRadius: 4
            }}
          >
            {notes.length === 0 ? (
              <p style={{ color: '#999' }}>No clinical notes found.</p>
            ) : (
              notes.map((item, index) => (
                <div key={index} style={{ marginBottom: 16 }}>
                  <div style={{ color: '#999', fontSize: 12 }}>{new Date(item.createdAt).toLocaleString()}</div>
                  <div style={{ marginTop: 8 }} dangerouslySetInnerHTML={{ __html: item.content }} />
                </div>
              ))
            )}
          </div>
          <Button
            type='primary'
            icon={<FontAwesomeIcon icon={faFilePdf} />}
            loading={generating}
            onClick={handleGeneratePDF}
            disabled={!notes.length}
            block
          >
            Generate Report
          </Button>
        </>
      )}
    </div>
  )
}

export default Report
